import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { checkIsActive } from "../../../../../_helpers";
import { Button, Tooltip } from "@material-ui/core";
import { Checkbox, Input, Spin, Select } from "antd";
import { SearchOutlined } from "@material-ui/icons";
import { StrategyTasksWork } from "../../../../../../app/assets/icons";
import FilterOptionsComponent from "./FilterOptionsComponent";
import { httpService } from "../../../../../../app/base/services/httpService.service";
import AuthService from "../../../../../../app/base/services/authentication.service";
import { UserRolesEnum } from "../../../../../../app/pages/auth/userRoles.enum";
import { SessionService } from "../../../../../../app/base/services/session.service";
import { getPercentage } from "../../../../../../app/pages/helper";
import { useResultStore } from "../../../../../../app/pages/workspace/results/components/ResultsStore";

function MenuResultsListSuperadmin({ setIsLoading }) {
   const [activeResult, setActiveResult] = useState([]);
   const [showFilters, setShowFilters] = useState(false);
   const [orgLoading, setOrgsLoading] = useState(false);
   const location = useLocation();
   const navigate = useNavigate();
   const params = useParams();
   const [menuItem, setMenuItem] = useState("");
   const [organizationName, setOrganizationName] = useState("");
   const currentWorkspaceId = SessionService.getItem("workspaceID");
   const {
      allOrganizations,
      setAllOrganizations,
      selectedAssessments,
      setSelectedSubmissionRounds,
      selectedSubmissionRounds,
      setActiveAssessment,
      setActiveSurvey,
      setActiveSurveySection,
      activeSectionSurvey,
      setRangesLoader,
      setAllSurveys,
      setSurveysDropdown,
      surveysDropdown,
      activeSurvey,
      setScorePerSurvey,
      setScorePerSection,
      // 
      submissionRounds,
      setSubmissionRounds,
      // 
      assessmentRanges,
      setAssessmentRanges,
      // 
      setRoundsLoader,
      setGraphsLoader,
      setTableViewLoader,

      // Table
      tableActiveSurvey,
      setTableActiveSurvey,
      tableViewData,
      setTableViewData,
      setOverAllScores,

      // Tab
      activeTab,
      setActiveTab
   } = useResultStore();

   const [selectedFilters, setSelectedFilters] = useState({
      orgSizes: "",
      countries: "",
      orgSectors: [],
      countryOfOperation: ""
   });
   const [allAssessments, setAllAssessments] = useState([]);
   const [assessmentLoader, setAssessmentLoader] = useState(false);
   const [activeSubmissionRounds, setActiveSubmissionRounds] = useState();

   useEffect(() => {
      // setGraphsLoader(false);
      fetchSubmissionRounds();
      setActiveTab(1);
      setActiveAssessment(null);
   }, []);

   const fetchSubmissionRounds = () => {
      setAssessmentLoader(true);
      httpService.get(
         `/Assesments/for-results/${currentWorkspaceId}?workspaceIdpageSize=1000&pageNumber=1`,
         (res) => {
            setAllAssessments(res.data);
            setAssessmentLoader(false);
         },
         (err) => {
            console.log(err);
            setAssessmentLoader(false);
         }
      );
   };

   useEffect(() => {
      if (allAssessments.length) {
         // setSelectedAssessments({ value: allAssessments[0]?.id, label: allAssessments[0]?.name });
         setActiveAssessment({ value: allAssessments[0]?.id, label: allAssessments[0]?.name });
      }
   }, [allAssessments]);

   useEffect(() => {
      setActiveSubmissionRounds([]);
      setActiveSurvey([]);
      setActiveSurveySection([]);
      setTableViewData([]);
      setTableActiveSurvey([]);

      if (selectedAssessments?.value) {
         setRangesLoader(true);
         httpService.get(
            `/Assesments/${selectedAssessments?.value}/submission-rounds-for-dropdown`,
            (res) => {
               setSubmissionRounds(res.data);
               setRangesLoader(false);
            },
            (err) => {
               console.log(err);
               setRangesLoader(false);
            }
         );
         httpService.get(
            `/Assesments/${selectedAssessments?.value}/ranges`,
            (res) => {
               setAssessmentRanges(res.data);
               setRoundsLoader(false);
            },
            (err) => {
               console.log(err);
               setRoundsLoader(false);
            }
         );
         httpService.get(
            `/Assesments/${selectedAssessments?.value}/surveys-for-dropdown`,
            (res) => {
               setAllSurveys(res.data);
               setSurveysDropdown(res.data);
            },
            (err) => {
               console.log(err);
            }
         );
      }
   }, [selectedAssessments]);

   useEffect(() => {
      getOverallResults();
      fetchAdminScorePerSurvey();
      fetchAdminScorePerSurveySection();
      fetchTableView();
   }, [allOrganizations]);

   useEffect(() => {
      setSelectedSubmissionRounds(activeSubmissionRounds);
      setAllOrganizations([]);
      setTableViewData([]);
      getOverallResults();
   }, [activeSubmissionRounds]);

   const getOverallResults = () => {
      if (allOrganizations?.length && activeSubmissionRounds?.value && selectedAssessments) {
         setGraphsLoader(true);
         let itm = "";
         itm = allOrganizations?.join("&OrganizationIds=");
         httpService
            .get(
               `/Results/${currentWorkspaceId}?AssessmentId=${selectedAssessments?.value}&SubmissionRangeId=${activeSubmissionRounds?.value}&OrganizationIds=${itm}`,
               (res) => {
                  setOverAllScores(res?.data);
                  setGraphsLoader(false);
               }
            )
            .catch(() => {
               setGraphsLoader(false);
            });
         fetchAdminScorePerSurvey();
         fetchAdminScorePerSurveySection();
      }
   };

   const fetchTableView = () => {
      if (
         allOrganizations.length &&
         activeSubmissionRounds?.value &&
         selectedAssessments?.value &&
         tableActiveSurvey?.length
      ) {
         let orgs = "";
         orgs = allOrganizations?.join("&OrganizationIds=");
         setTableViewLoader(true);
         if (params.id) {
            httpService
               .get(
                  `/Results/${currentWorkspaceId}/table-view?AssessmentId=${selectedAssessments?.value}&SubmissionRangeId=${activeSubmissionRounds?.value}&SurveyId=${tableActiveSurvey}&OrganizationIds=${orgs}`,
                  (res) => {
                     setTableViewData(res.data);
                     setTableViewLoader(false);
                  }
               )
               .catch(() => {
                  setTableViewLoader(false);
               });
         }
      } else {
         setTableViewData([]);
      }
   };

   const fetchScorePerSection = () => {
      let itm = "";
      if (activeSubmissionRounds) {
         itm = activeSubmissionRounds?.map((e) => e.id).join("&SubmissionRounds=");
      }
      if (params.id) {
         if (tableActiveSurvey) {
            httpService
               .get(
                  `/Results/${currentWorkspaceId}/survey/sections?AssessmentId=${params.id}&SurveyId=${tableActiveSurvey}&SubmissionRounds=${itm}`,
                  (res) => {
                     setScorePerSection(res.data);
                     setGraphsLoader(false);
                  }
               )
               .catch(() => {
                  setScorePerSection([]);
                  setGraphsLoader(false);
               });
         }
      }
   };


   const fetchAdminScorePerSurvey = () => {
      if (
         allOrganizations.length &&
         activeSubmissionRounds?.value &&
         selectedAssessments?.value &&
         activeSurvey
      ) {
         let orgs = "";
         let surveyList = "";
         orgs = allOrganizations?.join("&OrganizationIds=");
         if (activeSurvey?.length) {
            surveyList = activeSurvey?.map((e) => e.value)?.join("&SurveyIds=");
            surveyList = "&SurveyIds=" + surveyList;
         }
         if (params.id) {
            httpService
               .get(
                  `/Results/${currentWorkspaceId}/survey?AssessmentId=${selectedAssessments?.value}&SubmissionRangeId=${activeSubmissionRounds?.value}&OrganizationIds=${orgs}${surveyList}`,
                  (res) => {
                     setScorePerSurvey(res.data);
                     setGraphsLoader(false);
                  }
               )
               .catch(() => {
                  setGraphsLoader(false);
               });
         }
      } else {
         setScorePerSurvey([]);
      }
   };
   const fetchAdminScorePerSurveySection = () => {
      if (
         allOrganizations.length &&
         activeSubmissionRounds?.value &&
         selectedAssessments?.value &&
         activeSectionSurvey?.value
      ) {
         setGraphsLoader(true);
         let orgs = "";
         orgs = allOrganizations?.join("&OrganizationIds=");
         if (params.id) {
            httpService
               .get(
                  `/Results/${currentWorkspaceId}/survey/sections?AssessmentId=${selectedAssessments?.value}&SubmissionRangeId=${activeSubmissionRounds?.value}&SurveyId=${activeSectionSurvey?.value}&OrganizationIds=${orgs}`,
                  (res) => {
                     setScorePerSection(res.data);
                     setGraphsLoader(false);
                  }
               )
               .catch(() => {
                  setGraphsLoader(false);
               });
         }
      } else {
         setScorePerSection([]);
         setGraphsLoader(false);
      }
   };










   // 
   const handleFilterChange = (fieldName, value) => {
      setSelectedFilters((prevFilters) => ({
         ...prevFilters,
         [fieldName]: value
      }));
   };

   const handleApplyFilters = (selectedFilters) => {
      const payload = {};

      if (organizationName !== "") {
         payload.OrganizationName = organizationName;
      }

      if (selectedFilters.orgSizes) {
         payload.OrganizationSizeId = selectedFilters.orgSizes.value;
      }
      if (selectedFilters.countries) {
         payload.BaseCountryId = selectedFilters.countries.value;
      }
      if (selectedFilters.countryOfOperation) {
         payload.OperatingCountryId = selectedFilters.countryOfOperation.value;
      }
      if (selectedFilters.orgSectors && selectedFilters.orgSectors.length > 0) {
         payload.SectorIds = selectedFilters.orgSectors.map((sector) => sector.value);
      }

      const queryString = new URLSearchParams(payload).toString();
      const apiUrl =
         AuthService.isAuthorized([
            UserRolesEnum.InternationalOrganization,
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.Donor,
            UserRolesEnum.Consultant
         ]) && `Results/${currentWorkspaceId}/organizations?${queryString}`;

      httpService.get(apiUrl, (res) => {
         setMenuItem(res.data);
         setIsLoading(false);
      });
   };

   useEffect(() => {
      const timeout = setTimeout(() => {
         if (selectedAssessments?.value && selectedSubmissionRounds?.value) {
            const payload = {
               OrganizationName: organizationName !== "" ? organizationName : "",
               SubmissionRoundId: selectedSubmissionRounds?.value
            };
   
            setOrgsLoading(true);
            const queryString = new URLSearchParams(payload).toString();
            const apiUrl =
               AuthService.isAuthorized([
                  UserRolesEnum.InternationalOrganization,
                  UserRolesEnum.SuperAdmin,
                  UserRolesEnum.Donor,
                  UserRolesEnum.Consultant
               ]) &&
               `Results/${currentWorkspaceId}/organizations?AssessmentId=${selectedAssessments?.value}&${queryString}`;
   
            httpService.get(apiUrl, (res) => {
               setMenuItem(res.data);
               setIsLoading(false);
               setOrgsLoading(false);
            });
         } else {
            setIsLoading(false);
         }
      },500);

      return () => {
         clearTimeout(timeout);
      }
   }, [organizationName]);

   const clickedCard = (e) => {
      const isExisting = allOrganizations.some((el) => el === e);
      if (isExisting) {
         const filteredResults = allOrganizations.filter((el) => el !== e);
         setAllOrganizations(filteredResults);
      } else {
         setAllOrganizations([...allOrganizations, e]);
      }
   };

   useEffect(() => {
      if (selectedAssessments?.value && selectedSubmissionRounds?.value) {
         const payload = {
            OrganizationName: organizationName !== "" ? organizationName : ""
         };

         setOrgsLoading(true);
         const queryString = new URLSearchParams(payload).toString();
         const apiUrl =
            AuthService.isAuthorized([
               UserRolesEnum.InternationalOrganization,
               UserRolesEnum.SuperAdmin,
               UserRolesEnum.Donor,
               UserRolesEnum.Consultant
            ]) &&
            `Results/${currentWorkspaceId}/organizations?AssessmentId=${selectedAssessments?.value}&SubmissionRoundId=${selectedSubmissionRounds?.value}&${queryString}`;

         httpService.get(apiUrl, (res) => {
            setMenuItem(res.data);
            setIsLoading(false);
            setOrgsLoading(false);
         });
      } else {
         setIsLoading(false);
      }
   }, [selectedSubmissionRounds]);

   useEffect(() => {
      setMenuItem([]);
   }, [selectedAssessments]);

   // useEffect(() => {
   //    console.log("TEST", selectedAssessments);
   // }, [selectedAssessments]);

   // useEffect(() => {
   //    setAllOrganizations(activeResult);
   // }, [activeResult]);

   // useEffect(() => {
   //    if (menuItem?.length > 0) {
   //       clickedCard(menuItem[0]?.id);
   //    }
   // }, [menuItem]);

   const handleFilterClick = () => {
      setShowFilters(true);
   };

   const handleCloseFilters = () => {
      setShowFilters(false);
   };

   const handleClearAllFilters = () => {
      setSelectedFilters({
         orgSizes: "",
         countries: "",
         orgSectors: [],
         countryOfOperation: ""
      });
   };
   return (
      <>
         {showFilters ? (
            <FilterOptionsComponent
            onClose={handleCloseFilters}
            onFilterChange={handleFilterChange}
            onApplyFilters={handleApplyFilters}
            initialFilters={selectedFilters}
            onClearAllFilters={handleClearAllFilters}
            />
         ) : (
            <div>
               <div className="result-selects">
                  <h1>Results</h1>
                  <p>First select the <span>assessment</span> and <span>submission</span> round you wish. </p>
                  <div className="top-charts">
                     <div className="chart-assessments">
                        <h4>Assessment</h4>
                        <Spin spinning={assessmentLoader}>
                           <Select
                              style={{ minWidth: "100%" }}
                              showSearch
                              placeholder="All assessments"
                              className="select"
                              options={allAssessments?.map((e) => ({
                                 value: e.id,
                                 label: e.name
                              }))}
                              value={selectedAssessments}
                              onChange={(_, data) => {
                                 setAllOrganizations([]);
                                 setActiveSurvey([]);
                                 // setSelectedAssessments(data);
                                 setActiveAssessment(data);
                              }}
                           />
                        </Spin>
                     </div>
                     <div className="chart-submission">
                        <h4>Submission round</h4>
                        {/* <Spin spinning={roundsLoader}> */}
                           <Select
                              style={{ minWidth: "100%" }}
                              showSearch
                              placeholder="All submission rounds"
                              className="select"
                              options={submissionRounds?.map((e) => ({
                                 value: e.id,
                                 label: e.label
                              }))}
                              filterOption={(input, option) =>
                                 (option?.label?.toLowerCase() ?? "").includes(
                                    input?.toLowerCase()
                                 )
                              }
                              value={activeSubmissionRounds}
                              onChange={(_, data) => {
                                 setActiveSubmissionRounds(data);
                              }}
                           />
                        {/* </Spin> */}
                     </div>
                     {
                        activeTab === '2' &&
                        <div className="chart-survey">
                           <h4>Survey</h4>
                           <Select
                              style={{ minWidth: "100%" }}
                              showSearch
                              placeholder="All surveys"
                              className="select"
                              options={surveysDropdown?.map((e) => ({ value: e.id, label: e.name }))}
                              filterOption={(input, option) =>
                                 (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                              }
                              value={tableActiveSurvey}
                              onChange={(selectedSurvey) => {
                                 // setSelectedSurvey(selectedSurvey);
                                 setTableActiveSurvey(selectedSurvey);
                              }}
                           />
                        </div>
                     }
                  </div>
               </div>
               <div className="devider-line"><div className="line"></div></div>
               <div className="result-selects result-selects-org">
                  <h1>Select your organizations</h1>
                  <p><span>Then select up to 8 organizations from the list below</span> to have their results compared</p>
                  <div className="assessments-menu-sort">
                     <Input
                        autoComplete="off"
                        type="text"
                        prefix={<SearchOutlined />}
                        style={{ width: "100%" }}
                        value={organizationName}
                        onChange={(e) => setOrganizationName(e.target.value)}
                        placeholder="Search for an organization"
                     />
                  </div>
                  <div className="filter-button">
                     <Button onClick={handleFilterClick}>
                        Show filters
                     </Button>
                  </div>
               </div>
               {/* <div className="filter-container">
                  <div className="filter-main">
                     <img src={StrategyTasksWork} alt="StrategyTasksWork" />
                     <div>Compare results</div>
                  </div>
                  <Tooltip title={<p style={{maxWidth: '200px', fontSize: '12px', lineHeight: '16px', margin: 0}}>Use this tool to filter through various organizations based on your criteria and compare their respective results.</p>}  placement="top">
                     <Button className="filter-button" onClick={handleFilterClick}>
                        <div>Show filters</div>
                     </Button>
                  </Tooltip>
               </div> */}
               <div className="assessments-menu-list">
                  {/* <div className="assessments-menu-options">
                     <h2>Select your organization</h2>

                     <Tooltip title={<p style={{maxWidth: '200px', fontSize: '14px', lineHeight: '16px', margin: 0}}>Select up to 8 organizations from the list below to have their results compared</p>}  placement="top">
                        <div className="assessments-menu-sort">
                              <Input
                                 autoComplete="off"
                                 type="text"
                                 prefix={<SearchOutlined />}
                                 style={{ width: "100%" }}
                                 value={organizationName}
                                 onChange={(e) => setOrganizationName(e.target.value)}
                                 placeholder="Search for an organization"
                              />
                        </div>
                     </Tooltip>
                  </div> */}
                  <div className="assessments-cards">
                     {!orgLoading ? (
                        menuItem?.length ? (
                           <>
                              {menuItem?.map((item, i) => {
                                 return (
                                    <>
                                       <div
                                          className={`assessments-card admin-result ${
                                             allOrganizations?.find((e) => e === item?.id)
                                                ? "activeCard"
                                                : ""
                                          }`}
                                          key={i}
                                          onClick={() => clickedCard(item?.id)}
                                       >
                                          <div className="assessments-card-inner">
                                             <div className="assessments-card-upper">
                                                <div className="assessment-upper-image">
                                                   <div className="assessment-inner-image">
                                                      <img
                                                         src={
                                                            process.env.PUBLIC_URL +
                                                            "/media/svg/icons/General/office-building-1--office-building-work.svg"
                                                         }
                                                         alt="buildings"
                                                      />
                                                   </div>
                                                   <Checkbox
                                                      checked={
                                                         allOrganizations?.find(
                                                            (e) => e === item?.id
                                                         )
                                                            ? true
                                                            : false
                                                      }
                                                   ></Checkbox>
                                                </div>
                                                <h3
                                                   className="assessment-title"
                                                   style={{ wordBreak: "break-word" }}
                                                >
                                                   {item?.name}
                                                </h3>
                                             </div>
                                             <div className="assessment-lower-info">
                                                <div className="assessment-info">
                                                   <div className="assessment-location">
                                                      <img
                                                         src={
                                                            process.env.PUBLIC_URL +
                                                            "/media/svg/icons/General/map-pin-location.svg"
                                                         }
                                                         alt="map-pin"
                                                      />
                                                      <span style={{ wordBreak: "break-word" }}>
                                                         {item?.baseCountryName}
                                                      </span>
                                                   </div>
                                                   <div className="assessment-members">
                                                      <img
                                                         src={
                                                            process.env.PUBLIC_URL +
                                                            "/media/svg/icons/General/group-users-people-community.svg"
                                                         }
                                                         alt="users-community"
                                                      />
                                                      <span>{item?.membersCount}</span>
                                                   </div>
                                                </div>
                                                <div className="assessment-results">
                                                   <span className="assessment-results-text">
                                                      Score:
                                                   </span>
                                                   <span className="assessment-results-result">{`${getPercentage(
                                                      item?.averageScore || 0,
                                                      item?.averageMaxScore || 0
                                                   ).toFixed(2)}%`}</span>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </>
                                 );
                              })}
                           </>
                        ) : (
                           <>
                              <p style={{ textAlign: "center", color: "#555" }}>
                                 No active assessments and submission round
                              </p>
                           </>
                        )
                     ) : (
                        <Spin
                           style={{
                              position: "relative",
                              left: "50%",
                              transform: "translate(-50%)",
                              top: "20px"
                           }}
                        />
                     )}
                  </div>
               </div>
            </div>
         )}
      </>
   );
}

export default MenuResultsListSuperadmin;
